module.exports = __webpack_public_path__ + "static/media/gr_logo.19f7506b.png";